export default {
  state: {
    permisssions: null
  },
  getters: {
    permisssions: state => state.permisssions
  },
  mutations: {
    permisssionsSet (state, newPermisssions) {
      state.permisssions = newPermisssions
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storePermissions.js